<script setup lang="ts"></script>

<template>
    <footer class="card-footer">
        <slot />
    </footer>
</template>
